import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=5dc553bc&scoped=true"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=5dc553bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc553bc",
  null
  
)

export default component.exports